<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>All Survey</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
    </v-toolbar>
    <div v-if="alertMsg">
      <v-alert
        v-if="error == 0 && statusCode == 200"
        :value="true"
        type="success"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
      <v-alert
        v-if="error == 1 && statusCode == 204"
        :value="true"
        type="info"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
      <v-alert
        v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
        :value="true"
        type="warning"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
      <v-alert
        v-if="error == 1 && statusCode == 500"
        :value="true"
        type="error"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
    </div>
    <div v-if="indexData.total < 1" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <v-data-table
      :headers="headers"
      :items="indexData.data"
      :search="search"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :loading="loading"
      class="elevation-1"
    >
      <v-progress-linear color="blue" indeterminate></v-progress-linear>
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ props.header.text }}
            </span>
          </template>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>

      <template v-if="indexData.total > 0" v-slot:items="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.created_by }}</td>
        <td>{{ props.item.created_at }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.project_status_name }}</td>
        <td>{{ props.item.project_type_name }}</td>
        <td>{{ props.item.total_budget_amount }}</td>
        <td>{{ getTakaFromCoins(props.item.budget_remains) }}</td>
        <td>{{ props.item.number_of_response }}</td>
        <td>{{ props.item.total_pending_res }}</td>
        <td>{{ props.item.total_accepted_res }}</td>
        <td>{{ props.item.total_rejected_res }}</td>
        <td>{{ props.item.total_modified_res }}</td>
        <td>{{ props.item.begin_date }}</td>
        <td>{{ props.item.end_date }}</td>
        <td class="justify-center layout px-1">
          <v-tooltip bottom v-if="props.item.project_status_id == 1">
            <template v-slot:activator="{ on }">
              <v-icon
                small
                class="mr-2"
                v-on="on"
                @click="editItem(props.item.id)"
              >
                edit
              </v-icon>
            </template>
            <span>edit</span>
          </v-tooltip>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <v-icon
                small
                class="mr-2"
                v-on="on"
                @click="checkItem(props.item.id)"
              >
                visibility
              </v-icon>
            </template>
            <span>view</span>
          </v-tooltip>
          <v-tooltip bottom v-if="props.item.project_status_id == 8">
            <template v-slot:activator="{ on }">
              <v-icon
                small
                class="mr-2"
                v-on="on"
                @click="changeProjectStatusToPause(props.item.id)"
              >
                thumb_down
              </v-icon>
            </template>
            <span>pause</span>
          </v-tooltip>
          <v-tooltip bottom v-if="props.item.project_status_id == 11">
            <template v-slot:activator="{ on }">
              <v-icon
                small
                class="mr-2"
                v-on="on"
                @click="changeProjectStatusToLive(props.item.id)"
              >
                thumb_up
              </v-icon>
            </template>
            <span>resume</span>
          </v-tooltip>
        </td>
      </template>
      <template v-else v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">
          {{ errorMsg }}
        </v-alert>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
      <template v-slot:pageText>
        Rows {{ indexData.from }} - {{ indexData.to }} of {{ indexData.total }}
      </template>
    </v-data-table>
    <template>
      <div class="text-xs-center">
        <v-layout wrap>
          <v-flex xs10 sm10 md10>
            <v-pagination
              right
              v-model="indexData.current_page"
              :length="indexData.last_page"
              @input="onPageChange"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      dialog: false,
      alertMsg: false,
      apiUrl: "project",
      sl: 1,
      items: [
        { title: "5", value: 5 },
        { title: "10", value: 10 },
        { title: "25", value: 25 },
        { title: "50", value: 50 },
        { title: "All", value: -1 },
      ],
      headers: [
        { text: "Project Id", align: "left", value: "id" },
        { text: "Project Created By", align: "left", value: "created_by" },
        { text: "Project Created At", align: "left", value: "created_at" },
        { text: "Project Name", align: "left", value: "name" },
        {
          text: "Project Status",
          align: "left",
          sortable: false,
          value: "project_status_name",
        },
        { text: "Project Types", value: "project_type_name" },
        { text: "Total Budget(Tk)", value: "total_budget_amount" },
        { text: "Balance Remaining(Tk)", value: "budget_remains" },
        { text: "Total Response Required", value: "number_of_response" },
        { text: "Total Pending", value: "total_pending_res" },
        { text: "Total Accepted", value: "total_accepted_res" },
        { text: "Total Rejected", value: "total_rejected_res" },
        { text: "Total Modified", value: "total_modified_res" },
        { text: "Estimated Starting Time", value: "begin_date" },
        { text: "Project Ending Time", value: "end_date" },
        { text: "Actions", align: "center", value: "name", sortable: false },
      ],
      loading: false,
      search: "",
      pagination: {
        rowsPerPage: 5,
      },
      rowsPerPageItems: [5, 10, 20, 50, 100, 200, 500],
      rowsPerPage: 5,
      editedIndex: -1,
      editedItem: {},
      defaultItem: {
        rowsPerPage: 5,
      },
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
    },

    watch: {
      pagination() {
        this.rowsPerPage = this.pagination.rowsPerPage;
        this.onPageChange();
      },
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.$store.dispatch("getPaginatedIndexData", [
          "project",
          "",
          "",
          this.rowsPerPage,""
        ]);
      },
      getTakaFromCoins(coins) {
        return coins / 10;
      },
      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },
      checkItem(projectId) {
        this.$store.dispatch("getProjectDetails", [projectId, "client-view"]);
      },
      editItem(projectId) {
        localStorage.setItem("project_id_edit", JSON.stringify(projectId));
        this.$store.dispatch("indexDataAndRout", [
          "project-info",
          projectId,
          "/create-project-edit",
        ]);
      },
      changeProjectStatusToPause(projectId) {
        var popUpMsg = confirm("Are you sure you want to pause this project?");
        if (popUpMsg) {
          this.$store.dispatch("pauseOrResumeProjectStatus", [
            projectId,
            "pause-resume",
          ]);
        }
        this.close();
      },
      changeProjectStatusToLive(projectId) {
        var popUpMsg = confirm("Are you sure you want to live this project?");
        if (popUpMsg) {
          this.$store.dispatch("pauseOrResumeProjectStatus", [
            projectId,
            "pause-resume",
          ]);
        }
        this.close();
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      onPageChange() {
        this.paginationMethod();
      },

      paginationMethod() {
        this.loading = true;
        if (this.search) {
          this.$store.dispatch("getPaginatedIndexData", [
            "project",
            this.search,
            this.indexData.current_page,
            this.rowsPerPage,"",
          ]);
          this.loading = this.indexData.data ? false : true;
        } else {
          this.$store.dispatch("getPaginatedIndexData", [
            "project",
            "",
            this.indexData.current_page,
            this.rowsPerPage,"",
          ]);
          this.loading = !this.indexData.error ? false : true;
        }
        this.dialog = false;
      },
    },
  };
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem

  .imageResize
    width: auto
    height: auto
</style>
